import React from "react";
import { BarcodesCarousel } from "../BarcodesCarousel";
import { Data_Object_Types } from "../../constants/barcodes";

export const SerializedOptions = ({ options = [], workOrderId }) => {
  return (
    <BarcodesCarousel
      objectType={Data_Object_Types.WORK_ORDERS}
      objectId={workOrderId}
      vertical
      hideBar
      batch
    />
  );
};

export default SerializedOptions;
